import React from 'react'
import PropTypes from 'prop-types'
// import {useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Layout, Menu, Badge } from 'antd'
import { connect } from 'react-redux'

import {
  FaUndo,
  FaHome, //Home
  FaHotel, //Hotel
  FaNewspaper, //News
  FaUserFriends, //User
  FaUniversity, //Institution
  FaCalendarAlt, //Event
  FaBarcode, //product
  FaBuilding, //Company
  FaAddressCard, //People
  FaHandshake, //Collaborator
  FaImage, //ALbum
  FaFolderOpen, //Folder/
  FaBookDead, //Manga
  FaTrademark, //Brand
  FaGlobe, //Globe site
  FaCogs, //Cogs //Setting
  FaUserCog
} from 'react-icons/fa'
import logo from '../assets/images/logo.png'

function Sidebar(props) {
  const userInfo = props.userInfo
  const { Sider } = Layout
  const [t, i18n] = useTranslation()
  const location = useLocation()
  const [selectedKeys, setSelectedKeys] = React.useState([])
  const [siderItems, setSiderItems] = React.useState([])

  const sidebarClickHandle = () => {
    props.mediaSize === 'sm' && props.setCollapsed(true)
    props.mediaSize === 'xs' && props.setCollapsed(true)
  }

  const renderMenuItem = (key, icon, label) => {
    if (userInfo?.applyReturnCount > 0) {
      return {
        key,
        icon,
        label: <div>
          <Link onClick={sidebarClickHandle} to={`/${key}`}>{label}</Link>
          <Badge count={userInfo?.applyReturnCount} offset={[2, -4]}></Badge>
        </div>
      }
    }
    return {
      key,
      icon,
      label: <Link onClick={sidebarClickHandle} to={`/${key}`}>{label}</Link>
    }
  }

  const allSiderItems = [
    { key: 'home', icon: <FaHome />, label: <Link onClick={sidebarClickHandle} to="/home">{t('sidebar.home')}</Link> },
    { key: 'people', icon: <FaAddressCard />, label: <Link onClick={sidebarClickHandle} to="/people">{t('sidebar.people')}</Link> },
    { key: 'users', icon: <FaUserFriends />, label: <Link onClick={sidebarClickHandle} to="/users">{t('sidebar.users')}</Link> },
    { key: 'institutions', icon: <FaUniversity />, label: <Link onClick={sidebarClickHandle} to="/institutions">{t('sidebar.institutions')}</Link> },
    { key: 'collaborators', icon: <FaHandshake />, label: <Link onClick={sidebarClickHandle} to="/collaborators">{t('sidebar.collaborators')}</Link> },
    { key: 'companies', icon: <FaBuilding />, label: <Link onClick={sidebarClickHandle} to="/companies">{t('sidebar.companies')}</Link> },
    { key: 'articles', icon: <FaNewspaper />, label: <Link onClick={sidebarClickHandle} to="/articles">{t('sidebar.articles')}</Link> },
    { key: 'events', icon: <FaCalendarAlt />, label: <Link onClick={sidebarClickHandle} to="/events">{t('sidebar.events')}</Link> },
    { key: 'tutos', icon: <FaBarcode />, label: <Link onClick={sidebarClickHandle} to="/tuttos">{t('sidebar.products')}</Link> },
    { key: 'sites', icon: <FaGlobe />, label: <Link onClick={sidebarClickHandle} to="/sites">{t('sidebar.sites')}</Link> },
    { key: 'brands', icon: <FaTrademark />, label: <Link onClick={sidebarClickHandle} to="/brands">{t('sidebar.brands')}</Link> },
    { key: 'hotels', icon: <FaHotel />, label: <Link onClick={sidebarClickHandle} to="/hotels">{t('sidebar.hotels')}</Link> },
    { key: 'albums', icon: <FaImage />, label: <Link onClick={sidebarClickHandle} to="/albums">{t('sidebar.albums')}</Link> },
    { key: 'folders', icon: <FaFolderOpen />, label: <Link onClick={sidebarClickHandle} to="/folders">{t('sidebar.folders')}</Link> },
    { key: 'mangas', icon: <FaBookDead />, label: <Link onClick={sidebarClickHandle} to="/mangas">{t('sidebar.mangas')}</Link> },
    { key: 'settings', icon: <FaCogs />, label: <Link onClick={sidebarClickHandle} to="/settings">{t('sidebar.settings')}</Link> }
  ]

  const portal_cdec_org_cn = [
    { key: 'home', icon: <FaHome />, label: <Link onClick={sidebarClickHandle} to="/home">{t('sidebar.home')}</Link> },
    { key: 'users', icon: <FaUserFriends />, label: <Link onClick={sidebarClickHandle} to="/users">{t('sidebar.users')}</Link> },
    { key: 'institutions', icon: <FaUniversity />, label: <Link onClick={sidebarClickHandle} to="/institutions">{t('sidebar.institutions')}</Link> },
    { key: 'collaborators', icon: <FaHandshake />, label: <Link onClick={sidebarClickHandle} to="/collaborators">{t('sidebar.collaborators')}</Link> },
    { key: 'events', icon: <FaCalendarAlt />, label: <Link onClick={sidebarClickHandle} to="/events">{t('sidebar.events')}</Link> },
    renderMenuItem('returnApply', <FaUndo />, t('sidebar.returnApply')),
    { key: 'instAdminApply', icon: <FaCalendarAlt />, label: <Link onClick={sidebarClickHandle} to="/instAdminApply">{t('sidebar.instAdminApply')}</Link> },
    { key: 'people', icon: <FaUserCog />, label: <Link onClick={sidebarClickHandle} to="/people">{t('sidebar.account')}</Link> }
  ]

  const domainSiderItems = {
    'default': allSiderItems,
    'localhost': portal_cdec_org_cn, // 本地
    'portal-cdec.huahanwenhua.com': portal_cdec_org_cn, // test
    'portal.cdec.org.cn': portal_cdec_org_cn // 正式
  }

  React.useEffect(() => {

    let domain = window.location.hostname
    let siderItems = domainSiderItems['default']

    if (domainSiderItems[domain]) {
      siderItems = domainSiderItems[domain]

      let selectedKeys = []
      siderItems.forEach((item) => {
        if (location.pathname.indexOf(item.key) > -1) {
          selectedKeys.push(item.key)
        }
      })
      setSelectedKeys(selectedKeys)
    }

    setSiderItems(siderItems)
  }, [i18n.language, userInfo])

  return (
    <Sider
      theme={props.theme}
      className="site-sidebar"
      width={props.expandedWidth ? props.expandedWidth : '12.5vw'}
      collapsible
      collapsedWidth={props.collapsedWidth}
      collapsed={props.collapsed}
      trigger={null}
      breakpoint="sm"
      onBreakpoint={broken => {
        if (broken && !props.collapsed) {
          props.toggleCollapsed()
        }
        if (!broken && props.collapsed) {
          props.toggleCollapsed()
        }
      }}
      onCollapse={(value) => props.toggleCollapsed(value)}
    >
      <div className="site-logo">
        <img alt="logo" src={logo} style={{ width: '36px', height: '36px' }}/>
        {!props.collapsed && <h1 style={{ paddingLeft: '8px' }}>管理系统</h1>}
      </div>

      <Menu
        theme={props.theme}
        mode="inline"
        defaultSelectedKeys={selectedKeys}
        style={{ marginTop: 0 }}
        items={siderItems}
      />
    </Sider>
  )
}

Sidebar.propTypes = {
  theme: PropTypes.string,
  collapsed: PropTypes.bool,
  collapsedWidth: PropTypes.number,
  expandedWidth: PropTypes.number,
  toggleCollapsed: PropTypes.func,
  mediaSize: PropTypes.string,
  setCollapsed: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userReducer.userInfo
  }
}

export default connect(mapStateToProps)(Sidebar)